import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";

import { SummaryConstants as Constants } from '../../../Helpers/summaryconstants';
import SummaryCalculator from '../../../Helpers/summarycalculator';
import GTMHelper from '../../../Helpers/gtmHelper';

import { Button } from '../../1_Atoms/Button/Button';
import { CollapseSpecs } from '../../2_Molecules/Collapse/CollapseSpecs';

import { getLang } from '../../../utils';

export const FeaturedSpecs = ({openCollapsable,  ...props }) => {
    const { t, i18n } = useTranslation(['summary', 'general']);
    const navigate = useNavigate();
    const { year, carline, trim, model, packageCode } = useParams();
    const [summaryCalculator = new SummaryCalculator().reloadStoredData(), setSummaryCalculator] = React.useState();

    const [showBrochure]  = React.useState(summaryCalculator.AvailableTrim.model_year.show_brochure);
    const data = JSON.parse(sessionStorage.getItem(Constants.SpecificationData));
    const specsPDF = genereatePDFURL(true);
	const brochurePDF = genereatePDFURL(false);

    const gtmHelper = new GTMHelper();

    function genereatePDFURL(isSpec){
		const pdfType=isSpec?'specs':'brochure';
        let URL = `/globalassets/mazda-canada/${getLang()}/pdf/brochures/vehicles/${carline}/${year}-mazda-${carline.toLowerCase()}-${pdfType}-${getLang()}.pdf`;
        return URL;
    }

    function getTableSpecs(data) {
        let table  = "<table class='tablespecs'>"
            Object.keys(data).map((innerAttr, index) => {
                table += "<tbody>";
                table += "<tr>";

                let title=data[innerAttr].Title;
                if(!title.includes('http')){
                    title=title.replace(/([^<])\/([^>])/g, "$1 / $2");
                }
                let content=data[innerAttr].Data;
                if(!content.includes('http')){
                    content=content.replace(/([^<])\/([^>])/g, "$1 / $2");
                }
                if(data[innerAttr].type === 'Header') {
                    table += `<td colspan="2" class="cell category"><p class="paragraph--large text--white">${title}</p></td>`;
                } else {
                    table += `<td class="cell title">${title}</td>`;
                    table += `<td class="cell data">${content}</td>`;
                }

                table += "</tr>";
                table += "</tbody>";
            });
            table += "</table>";

        return table;
    }

    return (
        <div className="mz-summary--featured">
            <h3>{t("full_specifications")}</h3>

            {data ? Object.keys(data).map((innerAttr, index) => {
                const key = `specificationsCollapse${index}`;
                const tableHtml = getTableSpecs(data[innerAttr]);
                return (
                    <CollapseSpecs key={key} isOpen={openCollapsable === key} ColCarText1={innerAttr} ColBoxText={tableHtml} id={String(Math.floor(Math.random() * 100000000))} />
                )}) : null
            }

            <div className="mz-summary--featured__cta">
				<Button
                    primary={false}
                    label={t("btn_download_full_specs")}
                    icon={true}
                    iconBefore={true}
                    size={1.4}
                    svg_list="downloadbrochure"
                    onClick={() => {  
                        window.open(specsPDF, "_blank")
                        gtmHelper.setGTM({'action':'Download', 'type': 'Specs PDF', 'value': specsPDF}, true , false);
                    }}
                />
				{showBrochure && <Button
                    primary={false}
                    label={t("btn_download_brochure")}
                    icon={true}
                    iconBefore={true}
                    size={1.4}
                    svg_list="downloadbrochure"
                    onClick={() => {  
                        window.open(brochurePDF, "_blank");
                        gtmHelper.setGTM({'action':'Download', 'type': 'Brochure PDF', 'value': brochurePDF}, true , false);
                    }}
                />}
            </div>
        </div>
)
};